module.exports = __webpack_public_path__ + "static/assets/86c0614a225dd4e26ccd51cd06e3b2af.png";